import React, { useState } from "react";
import { SITES } from "./types/Emailstypes";
import SiteSelector from "./components/SitesSection/SiteSelector";
import ListingsSection from "./components/ListingsSection/ListingsSection";

interface GroupsGBPProps {
  onNavigateHome?: () => void;
  onNavigateToGBP?: (id: number) => void;
}
const GroupsGBP: React.FC<GroupsGBPProps> = ({ onNavigateToGBP }) => {
  const [selectedSiteId,  setSelectedSiteId]  = useState<string | null>(null);
  const [confirmedSiteId, setConfirmedSiteId] = useState<string | null>(null);
  const [localSearch,     setLocalSearch]     = useState("");

  const confirmedSite = SITES.find((s) => s.id === confirmedSiteId) ?? null;

   const handleConfirmSite = (id: string) => {
    setSelectedSiteId(id);
    setConfirmedSiteId(id);
    setLocalSearch("");
  };

  return (
    <div className="min-h-screen">
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in { animation: fade-in 0.22s ease both; }
      `}</style>

      <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-10 py-8">

        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-6 py-6 mb-6">
          <SiteSelector
            selectedSiteId={selectedSiteId}
            onSelect={setSelectedSiteId}
            onConfirm={handleConfirmSite}
          />
        </div>

        {confirmedSite && (
          <div
            key={confirmedSite.id}
            className="bg-white rounded-2xl border border-slate-100 shadow-sm px-6 py-6 animate-fade-in"
          >
            <ListingsSection
              site={confirmedSite}
              localSearch={localSearch}
              setLocalSearch={setLocalSearch}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupsGBP;